import React from "react";
import { Route, Redirect } from "react-router-dom";

import cookie from "react-cookies";

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      window.loggedInBrowserHistory = props.history;
      if (
        localStorage.getItem("PortalUserSettings") &&
        cookie.load("AuthToken")
      ) {
        return <Component {...props} />;
      } else {
        if (props.location.pathname !== "/login" && props.location.pathname !== "/unsubscribe") {
          localStorage.setItem(
            "LastLocationHash",
            props.location.pathname.toString()
          );
          localStorage.setItem("LastLocationHashSearch", props.location.search);
        }
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        );
      }
    }}
  />
);
